import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as styles from './InnerImageZoom.css';

const cx = classNames.bind(styles);

const ZoomImage = ({
    src,
    fadeDuration,
    top,
    left,
    isZoomed,
    onLoad,
    onDragStart,
    onDragEnd,
    onClose,
    onFadeOut,
    enableZoomOnProductImage,
}) => {
    const ZoomContainer_zoomImageStyle = dt([
        'sm:!w-auto',
        'sm:!max-w-none',
        'absolute',
        'invisible',
        'opacity-0',
        'pointer-events-none',
        'block',
    ]);
    const ZoomContainer_displayZoomImage = dt([
        'sm:!visible',
        'sm:!opacity-100',
        !enableZoomOnProductImage ?? 'sm:!pointer-events-auto',
        !enableZoomOnProductImage ?? 'smMd:!top-0',
        !enableZoomOnProductImage ?? 'smMd:!h-screen',
        !enableZoomOnProductImage ?? 'smMd:!mb-2',
    ]);
    const zoomImage = () => {
        return (
            <img
                className={`${cx('ZoomContainer_zoomImage', ZoomContainer_zoomImageStyle)} ${
                    isZoomed ? ZoomContainer_displayZoomImage : ''
                }`}
                style={{
                    top,
                    left,
                    transition: `opacity ${fadeDuration}ms linear, visibility ${fadeDuration}ms linear`,
                }}
                src={src}
                onLoad={onLoad}
                onTouchStart={onDragStart}
                onTouchEnd={onDragEnd}
                onMouseDown={onDragStart}
                onMouseUp={onDragEnd}
                onTransitionEnd={onFadeOut}
                draggable="false"
                alt=""
            />
        );
    };
    return (
        <>
            <div>{zoomImage()}</div>

            {onClose && (
                <button
                    className={cx(
                        'ZoomContainer_button ZoomContainer_close',
                        isZoomed ? 'ZoomContainer_displayClose' : ''
                    )}
                    style={{
                        transition: `opacity ${fadeDuration}ms linear, visibility ${fadeDuration}ms linear`,
                        display: 'none',
                    }}
                    onClick={onClose}
                    aria-label="Zoom Out"
                />
            )}
        </>
    );
};

ZoomImage.propTypes = {
    src: PropTypes.string,
    fadeDuration: PropTypes.number,
    top: PropTypes.number,
    left: PropTypes.number,
    isZoomed: PropTypes.bool,
    onLoad: PropTypes.func,
    onDragStart: PropTypes.func,
    onDragEnd: PropTypes.func,
    onClose: PropTypes.func,
    onFadeOut: PropTypes.func,
    enableZoomOnProductImage: PropTypes.bool.isRequired,
};

export default ZoomImage;
